@if (project$ | async; as project) {
  @if (menuGroups$ | async; as menuGroups) {
    <div class="project-main">
      <div class="project-menu">
        @for (menuPositions of menuGroups; track $index) {
          @for (menu of menuPositions; track $index) {
            @if (!menu.hidden) {
              @if (menu.submenu?.length) {
                <button
                  mat-icon-button
                  [attr.data-testid]="'project-menu-' + (menu.name | cssclass)"
                  (click)="registerMatomoSelectMenu(menu.name)"
                  [disableRipple]="true"
                  class="menu-item"
                  [matTooltip]="menu.name"
                  [matTooltipPosition]="'right'"
                  [matMenuTriggerFor]="subMenu"
                  [matBadge]="menu.badge"
                  [disabled]="menu.disabled">
                  @if (menu.svgIcon) {
                    <mat-icon [svgIcon]="menu.icon"></mat-icon>
                  } @else {
                    <mat-icon class="material-icons-outlined" inline>{{ menu.icon }}</mat-icon>
                  }
                </button>
                <mat-menu #subMenu xPosition="after">
                  @for (item of menu.submenu; track $index) {
                    <menu
                      mat-menu-item
                      [routerLink]="'/project/' + project.id + '/' + item.path"
                      (click)="registerMatomoCompareMode()">
                      {{ item.name }}
                    </menu>
                  }
                </mat-menu>
              } @else {
                <button
                  mat-icon-button
                  [attr.data-testid]="'project-menu-' + (menu.name | cssclass)"
                  [attr.data-guide]="menu.path === 'tracker' ? 'tracker-menu' : null"
                  (click)="refreshDiscrepancies(); registerMatomoSelectMenu(menu.name)"
                  [disableRipple]="true"
                  class="menu-item"
                  [matTooltip]="menu.name"
                  [matTooltipPosition]="'right'"
                  [routerLink]="'/project/' + project.id + '/' + menu.path"
                  routerLinkActive="active"
                  [matBadge]="menu.badge"
                  [disabled]="menu.disabled">
                  @if (menu.svgIcon) {
                    <mat-icon [svgIcon]="menu.icon"></mat-icon>
                  } @else {
                    <mat-icon class="material-icons-outlined" inline>{{ menu.icon }}</mat-icon>
                  }
                </button>
              }
            }
          }
          @if (!$last) {
            <div class="separator"></div>
          }
        }
      </div>
      <div class="project-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  }
}
